export const BUTTON_IDENTIFIER = 'kmcc-accept-some-cookies';



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/acceptSomeCookiesButton.config.js